export enum WAType {
  All = 'All',
  Webapp = 'Webapps',
}

export enum WAFilter {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETED = 'deleted',
}
